if (!window.Eurus.loadedScript.has('cart-fields.js')) {
  window.Eurus.loadedScript.add('cart-fields.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartFields', (isCartDrawer, currentLanguage, excludeDay, holidayList, dateFormat) => ({
        customField: '',
        customFieldLabel: '',
        customFieldRequired: false,
        customFieldError: false,
        customFieldErrorMessage: 'Please enter 4 English letters followed by 4 numbers, for example: RQNA8818.',
        showSaudiShortCode: false,
        shopifyCountry: '',
        openField: false,
        t: '',
        cartDeliveryDateField: '',
        deliveryDateFieldError: false,
        deliveryDateString: 'Select date',   
        tDeliveryDate: '',
        deliveryDateValidationError: false,
        init() {
          // Read shopify country from nested cart-fields node if present
          const fieldsEl = this.$el.querySelector('[x-cart-fields-data]') || document.getElementById('cart-fields');
          if (fieldsEl) {
            try {
              const data = xParseJSON(fieldsEl.getAttribute('x-cart-fields-data'));
              if (data) {
                this.customFieldLabel = data.custom_field_label || this.customFieldLabel;
                this.shopifyCountry = data.shopify_country || '';
                this.customFieldRequired = !!data.custom_field_required;
                this.customFieldErrorMessage = data.custom_field_error || this.customFieldErrorMessage;
                const patternSource = data.custom_field_pattern && String(data.custom_field_pattern).trim()
                  ? data.custom_field_pattern
                  : '^[A-Z]{4}[0-9]{4}$';
                this.custom_field_pattern = new RegExp(patternSource);
              }
            } catch (e) {}
          }
          this.customField = localStorage.cart_custom_field ? localStorage.cart_custom_field : '';
          this.customFieldError = false;
          this.refreshSaudiVisibility();
          if (!this._saudiCountryListenersBound) {
            this._saudiCountryListenersBound = true;
            const refresh = () => this.refreshSaudiVisibility();
            document.addEventListener('perfyra:country-ready', refresh);
            document.addEventListener('perfyra:country-changed', refresh);
            document.addEventListener('currency:change', refresh);
            document.addEventListener('doubly:currency:change', refresh);
            window.addEventListener('storage', (e) => {
              if (!e.key || e.key === 'perfyra-gulf-country' || e.key === 'currency' || e.key === 'doubly_currency') refresh();
            });
            try {
              new MutationObserver(refresh).observe(document.documentElement, {
                attributes: true,
                attributeFilter: ['data-perfyra-currency']
              });
            } catch (e2) {}
            // Re-check when cart opens (currency may have changed while closed)
            try {
              document.addEventListener('eurus:cart-drawer:load', refresh);
              document.addEventListener('eurus:cart:updated', refresh);
            } catch (e3) {}
          }
        },
        getLiveCurrencyCode() {
          const attr = (document.documentElement.getAttribute('data-perfyra-currency') || '').toUpperCase();
          if (attr) return attr;

          try {
            if (window.DoublyCurrency && window.DoublyCurrency.currentCurrency) {
              const d = String(window.DoublyCurrency.currentCurrency).toUpperCase();
              if (d && d !== 'UNDEFINED') return d;
            }
          } catch (e) {}

          try {
            if (window.DoublyCurrency && window.DoublyCurrency.cookie && typeof window.DoublyCurrency.cookie.read === 'function') {
              const c = String(window.DoublyCurrency.cookie.read() || '').toUpperCase();
              if (c && c !== 'UNDEFINED') return c;
            }
          } catch (e2) {}

          try {
            const saved = JSON.parse(localStorage.getItem('perfyra-gulf-country') || 'null');
            if (saved && saved.currency) {
              const cur = String(saved.currency).toUpperCase();
              if (cur) return cur;
            }
          } catch (e3) {}

          try {
            const ls = (localStorage.getItem('currency') || localStorage.getItem('doubly_currency') || localStorage.getItem('doublyCurrency') || '').toUpperCase();
            if (ls) return ls;
          } catch (e4) {}

          // Infer from visible cart/drawer prices (BHD / SAR / etc.)
          const sample = document.querySelector('#CartDrawer .money, #update-cart .money, #CartDrawer-Checkout, .cart-open .money');
          if (sample) {
            const text = sample.textContent || '';
            const match = text.match(/\b(SAR|BHD|JOD|AED|KWD|QAR|OMR)\b/i);
            if (match) return match[1].toUpperCase();
          }

          return '';
        },
        getSelectedGulfCountry() {
          const cur = this.getLiveCurrencyCode();
          const currencyToCountry = {
            SAR: 'SA', AED: 'AE', KWD: 'KW', QAR: 'QA', BHD: 'BH', JOD: 'JO', OMR: 'OM'
          };
          if (cur && currencyToCountry[cur]) return currencyToCountry[cur];

          try {
            const saved = JSON.parse(localStorage.getItem('perfyra-gulf-country') || 'null');
            if (saved && saved.country) return String(saved.country).toUpperCase();
          } catch (e) {}

          // Do NOT fall back to Shopify market — Doubly picker is the source of truth
          return '';
        },
        refreshSaudiVisibility() {
          const isSA = this.getSelectedGulfCountry() === 'SA';
          const wasSA = this.showSaudiShortCode;
          this.showSaudiShortCode = isSA;
          this.customFieldRequired = isSA;
          // Visibility is controlled by standalone sync (class), not Alpine x-show
          if (typeof window.PerfyraSyncSaudiShortCode === 'function') {
            window.PerfyraSyncSaudiShortCode();
          }
          if (!isSA) {
            this.customFieldError = false;
            if (wasSA && this.customField) {
              this.customField = '';
              this.save('');
            }
          }
        },
        isValidCustomField(value) {
          const pattern = this.custom_field_pattern || /^[A-Z]{4}[0-9]{4}$/;
          return pattern.test(String(value || '').trim());
        },
        loadData() {
          const data = xParseJSON(this.$el.getAttribute('x-cart-fields-data'));

          this.customField = localStorage.cart_custom_field ? localStorage.cart_custom_field : '';
          this.customFieldLabel = data.custom_field_label;
          this.customFieldRequired = !!data.custom_field_required;
          this.customFieldErrorMessage = data.custom_field_error || this.customFieldErrorMessage;
          this.shopifyCountry = data.shopify_country || this.shopifyCountry || '';
          const patternSource = data.custom_field_pattern && String(data.custom_field_pattern).trim()
            ? data.custom_field_pattern
            : '^[A-Z]{4}[0-9]{4}$';
          this.custom_field_pattern = new RegExp(patternSource);
          this.customFieldError = false;
          this.refreshSaudiVisibility();
          if (this.showSaudiShortCode) {
            this.save();
          }

          if (!isCartDrawer) {
            const input = document.getElementById("x-cart-custom-field");
            if (input) {
              input.addEventListener("focusout", () => {
                this.saveAndCloseCustomField(false);
              });
            }
          }

          if (!this._cartValidateBound) {
            this._cartValidateBound = true;
            document.addEventListener('eurus:cart:validate', (e) => {
              this.refreshSaudiVisibility();
              if (!this.showSaudiShortCode) {
                this.customFieldError = false;
                return;
              }
              this.customField = localStorage.cart_custom_field ? localStorage.cart_custom_field : this.customField;
              const empty = !this.customField || this.customField.length == 0;
              const invalid = this.customField && !this.isValidCustomField(this.customField);
              if ((this.customFieldRequired && empty) || invalid) {
                Alpine.store('xCartHelper').validated = false;
                // Only show the red message when checking out (or typed invalid value)
                if ((e.detail && e.detail.isCheckOut) || invalid) {
                  this.customFieldError = true;
                }
              } else {
                this.customFieldError = false;
              }
            });
          }
        },
        saveAndCloseCustomField(shouldClose = true, options = {}) {
          if (!this.showSaudiShortCode) {
            this.customFieldError = false;
            return true;
          }
          this.customField = String(this.customField || '').toUpperCase().trim();

          // Empty field: do not show validation until checkout
          if (!this.customField) {
            this.customFieldError = !!options.requireFilled;
            this.save('');
            if (shouldClose) {
              Alpine.store('xCartHelper').openField = false;
            }
            return !options.requireFilled;
          }

          if (!this.isValidCustomField(this.customField)) {
            this.customFieldError = true;
            return false;
          }
          this.customFieldError = false;
          this.save(this.customField);
          if (shouldClose) {
            Alpine.store('xCartHelper').openField = false;
          }
          return true;
        },
        save(custom_field_value) {
          clearTimeout(this.t);

          if (typeof custom_field_value !== 'undefined') {
            this.customField = String(custom_field_value || '').toUpperCase().trim();
          }
          const func = () => {
            var attributes = { attributes: {} }
            attributes.attributes[this.customFieldLabel] = this.showSaudiShortCode ? this.customField : '';
            Alpine.store('xCartHelper').updateCart(attributes, true);
            localStorage.cart_custom_field = this.showSaudiShortCode ? this.customField : '';
          }
          
          this.t = setTimeout(() => {
            func();
          }, 200);
        },
        loadDeliveryFieldData(required) {
          this.cartDeliveryDateField = localStorage.cart_delivery_date_field ? localStorage.cart_delivery_date_field : '';
          const deliveryDateInputEl = document.getElementById('x-cart-delivery-date-field');
          if (deliveryDateInputEl) {
            this.deliveryDateValidate(this.cartDeliveryDateField, deliveryDateInputEl);
            this.saveDeliveryDateField();
          }
          
          document.addEventListener('eurus:cart:validate', (e) => {           
            this.cartDeliveryDateField = localStorage.cart_delivery_date_field ? localStorage.cart_delivery_date_field : '';
            if (this.cartDeliveryDateField && isCartDrawer) {
              const date = new Date(this.cartDeliveryDateField);
              const dayOfTheMonth = date.getDate();
              const fullMonth = new Intl.DateTimeFormat(`${currentLanguage}`, { month: "long" }).format(date);
              if (dateFormat == 'mm-dd') {
                this.deliveryDateString = `${fullMonth} ${dayOfTheMonth < 10 ? `0${dayOfTheMonth}` : dayOfTheMonth}`;
              } else {
                this.deliveryDateString = `${dayOfTheMonth < 10 ? `0${dayOfTheMonth}` : dayOfTheMonth} ${fullMonth}`;
              }
            }
            if (required && (!this.cartDeliveryDateField || this.cartDeliveryDateField.length == 0)) {
              this.deliveryDateFieldError = true;      
              this.deliveryDateValidationError = false;       
              Alpine.store('xCartHelper').validated = false;
              if (e.detail.isCheckOut) {
                Alpine.store('xCartHelper').openField = 'delivery_date_field'
              }
            } else {
              this.deliveryDateFieldError = false;
            }
          });
        },
        _getNextValidDate(date, minDate, maxDate) {
          const holidayArray = holidayList ? holidayList.split(',').map(holiday => holiday.trim()) : [];
          let isInvalid = true;

          while (isInvalid) {
            isInvalid = false;
            // Weekend check
            if (excludeDay === 'saturday_sunday' && (date.getDay() === 6 || date.getDay() === 0)) {
              if (date.getDay() === 6) {
                date.setDate(date.getDate() + 2);
              } else {
                date.setDate(date.getDate() + 1);
              }
              this.deliveryDateValidationError = true;
              this.deliveryDateFieldError = false;
              isInvalid = true;
              continue;
            }

            if (excludeDay === 'saturday' && date.getDay() === 6) {
              date.setDate(date.getDate() + 1);
              this.deliveryDateValidationError = true;
              this.deliveryDateFieldError = false;
              isInvalid = true;
              continue;
            }

            if (excludeDay === 'sunday' && date.getDay() === 0) {
              date.setDate(date.getDate() + 1);
              this.deliveryDateValidationError = true;
              this.deliveryDateFieldError = false;
              isInvalid = true;
              continue;
            }
            // Holiday check
            if (holidayArray.length > 0) {
              const dayOfMonth = date.getDate();
              const monthName = new Intl.DateTimeFormat(currentLanguage, { month: "long" }).format(date);
              const dateString = `${monthName} ${dayOfMonth < 10 ? `0${dayOfMonth}` : dayOfMonth}`;

              if (holidayArray.includes(dateString)) {
                date.setDate(date.getDate() + 1);
                this.deliveryDateValidationError = true;
                this.deliveryDateFieldError = false;
                isInvalid = true;
                continue;
              }
            }

            // Out of range check
            if ((minDate && date < minDate) || (maxDate && date > maxDate)) {
              if (date < minDate) {
                date = new Date(minDate.getTime());
              }
              if (date > maxDate) {
                date = new Date(maxDate.getTime());
              }
              this.deliveryDateValidationError = true;
              this.deliveryDateFieldError = false;
              isInvalid = true;
              break;
            }
          }
          return date;
        },
        deliveryDateValidate(value, el) {
          if (value) {
            let date = new Date(value);
            const maxDate = new Date(el.max);
            const minDate = new Date(el.min);
            date = this._getNextValidDate(date, minDate, maxDate);
            this.cartDeliveryDateField = date.toISOString().split("T")[0];
          }
        },
        saveDeliveryDateField(delivery_date_field_value, isCartPage) {
          clearTimeout(this.tDeliveryDate);

          if (delivery_date_field_value) {
            this.cartDeliveryDateField = delivery_date_field_value
          }
          const func = () => {
            const deliveryDateInputEl = document.getElementById('x-cart-delivery-date-field');
            if (deliveryDateInputEl) {
              this.deliveryDateValidate(this.cartDeliveryDateField, deliveryDateInputEl);
            }
            if (isCartDrawer && this.cartDeliveryDateField) {
              const date = new Date(this.cartDeliveryDateField);
              const dayOfTheMonth = date.getDate();
              const fullMonth = new Intl.DateTimeFormat(`${currentLanguage}`, { month: "long" }).format(date);
              if (dateFormat == 'mm-dd') {
                this.deliveryDateString = `${fullMonth} ${dayOfTheMonth < 10 ? `0${dayOfTheMonth}` : dayOfTheMonth}`;
              } else {
                this.deliveryDateString = `${dayOfTheMonth < 10 ? `0${dayOfTheMonth}` : dayOfTheMonth} ${fullMonth}`;
              }
            }
            var attributes = { attributes: {} }
            attributes.attributes['Delivery date'] = this.cartDeliveryDateField;
            Alpine.store('xCartHelper').updateCart(attributes, true);
            localStorage.cart_delivery_date_field = this.cartDeliveryDateField;
            if (!isCartPage) {
              this.deliveryDateValidationError = false;
            }
          }
          
          this.tDeliveryDate = setTimeout(() => {
            func();
          }, 200);
        },
      }));
    })
  });
}
/* Standalone sync: Saudi Short Code follows bottom-left currency icon without page reload */
(function () {
  if (window.__perfyraSaudiShortCodeSyncV2) return;
  window.__perfyraSaudiShortCodeSyncV2 = true;

  var lastShow = null;
  var syncTimer = null;

  function readCurrency() {
    // 1) Explicit converter attribute
    var attr = (document.documentElement.getAttribute('data-perfyra-currency') || '').toUpperCase();
    if (attr) return attr;

    // 2) Doubly live state
    try {
      if (window.DoublyCurrency && window.DoublyCurrency.currentCurrency) {
        var d = String(window.DoublyCurrency.currentCurrency).toUpperCase();
        if (d && d !== 'UNDEFINED') return d;
      }
    } catch (e) {}

    try {
      if (window.DoublyCurrency && window.DoublyCurrency.cookie && typeof window.DoublyCurrency.cookie.read === 'function') {
        var c = String(window.DoublyCurrency.cookie.read() || '').toUpperCase();
        if (c && c !== 'UNDEFINED') return c;
      }
    } catch (e2) {}

    // 3) Doubly select / nice-select (bottom-left icon)
    var select = document.querySelector('select.currency-switcher[name="doubly-currencies"], select.currency-switcher, .doubly-float select, .doubly-wrapper select');
    if (select && select.value) return String(select.value).toUpperCase();

    var selected = document.querySelector('.doubly-nice-select .option.selected');
    if (selected && selected.getAttribute('data-value')) {
      return String(selected.getAttribute('data-value')).toUpperCase();
    }

    var currentLabel = document.querySelector('.doubly-float .current, .doubly-wrapper .current, .doubly-nice-select .current');
    if (currentLabel) {
      var labelText = currentLabel.textContent || '';
      var labelMatch = labelText.match(/\b(SAR|BHD|JOD|AED|KWD|QAR|OMR)\b/i);
      if (labelMatch) return labelMatch[1].toUpperCase();
    }

    // 4) Saved gulf choice / localStorage (trusted over random money nodes)
    try {
      var saved = JSON.parse(localStorage.getItem('perfyra-gulf-country') || 'null');
      if (saved && saved.currency) return String(saved.currency).toUpperCase();
    } catch (e3) {}

    try {
      var ls = (localStorage.getItem('currency') || localStorage.getItem('doubly_currency') || localStorage.getItem('doublyCurrency') || '').toUpperCase();
      if (ls) return ls;
    } catch (e4) {}

    // 5) Cart drawer money text only (avoid first stale product card)
    var cartMoney = document.querySelector('#CartDrawer .money, #update-cart .money, .cart-open .money');
    if (cartMoney) {
      var cartText = cartMoney.textContent || '';
      var cartMatch = cartText.match(/\b(SAR|BHD|JOD|AED|KWD|QAR|OMR)\b/i);
      if (cartMatch) return cartMatch[1].toUpperCase();
    }

    return '';
  }

  function isSaudi() {
    return readCurrency() === 'SAR';
  }

  function applyVisibility(show) {
    document.querySelectorAll('#cart-fields, [data-saudi-short-code]').forEach(function (el) {
      if (show) el.classList.remove('pf-saudi-shortcode-hidden');
      else el.classList.add('pf-saudi-shortcode-hidden');
      el.setAttribute('aria-hidden', show ? 'false' : 'true');
      // Clear any leftover inline display from older builds
      el.style.removeProperty('display');
      el.removeAttribute('hidden');
    });

    try {
      document.querySelectorAll('[x-data]').forEach(function (root) {
        if (!root._x_dataStack) return;
        root._x_dataStack.forEach(function (data) {
          if (data && typeof data.showSaudiShortCode !== 'undefined') {
            data.showSaudiShortCode = show;
            data.customFieldRequired = show;
          }
        });
      });
    } catch (e) {}
  }

  function syncSaudiShortCode(force) {
    var show = isSaudi();
    if (!force && lastShow === show) return;
    lastShow = show;
    applyVisibility(show);
  }

  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncSaudiShortCode(true);
    }, 80);
  }

  function onCurrencyUiClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (
      t.closest('.doubly-float') ||
      t.closest('.doubly-wrapper') ||
      t.closest('.doubly-nice-select') ||
      t.closest('.currency-switcher') ||
      t.closest('[data-pcp-reopen]') ||
      t.closest('[data-pcp-country]')
    ) {
      scheduleSync();
      setTimeout(function () { syncSaudiShortCode(true); }, 300);
      setTimeout(function () { syncSaudiShortCode(true); }, 900);
    }
  }

  function onCurrencyUiChange(e) {
    var el = e.target;
    if (!el || !el.matches) return;
    if (el.matches('select.currency-switcher, select[name="doubly-currencies"], .doubly-float select, .doubly-wrapper select')) {
      scheduleSync();
      setTimeout(function () { syncSaudiShortCode(true); }, 300);
    }
  }

  function boot() {
    syncSaudiShortCode(true);
    document.addEventListener('perfyra:country-changed', function () { syncSaudiShortCode(true); });
    document.addEventListener('perfyra:country-ready', function () { syncSaudiShortCode(true); });
    document.addEventListener('currency:change', function () { syncSaudiShortCode(true); });
    document.addEventListener('doubly:currency:change', function () { syncSaudiShortCode(true); });
    document.addEventListener('eurus:cart-drawer:load', function () { syncSaudiShortCode(true); });
    document.addEventListener('eurus:cart:updated', function () { scheduleSync(); });
    document.addEventListener('click', onCurrencyUiClick, true);
    document.addEventListener('change', onCurrencyUiChange, true);
    window.addEventListener('storage', function (e) {
      if (!e.key || e.key === 'perfyra-gulf-country' || e.key === 'currency' || e.key === 'doubly_currency') {
        syncSaudiShortCode(true);
      }
    });

    try {
      new MutationObserver(function () { scheduleSync(); }).observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-perfyra-currency']
      });
    } catch (e) {}

    // Soft poll — only applies when value actually changes
    setInterval(function () { syncSaudiShortCode(false); }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.PerfyraSyncSaudiShortCode = function () { syncSaudiShortCode(true); };
})();
